import React, { useEffect } from "react";
import { CloseOutlined } from "@ant-design/icons";
import "./index.scss";

interface BasePopupProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  showButton?: boolean;
  tips?: React.ReactNode;
}

const BasePopup: React.FC<BasePopupProps> = ({
  open,
  onClose,
  title,
  children,
  footer,
  showButton = true,
  tips,
}) => {
  // 处理 ESC 键关闭
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape" && open) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("keydown", handleEsc);
      // 禁止背景滚动
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      {/* 遮罩层 */}
      <div className='popup-overlay' onClick={onClose} />

      {/* 弹窗主体 */}
      <div className='popup-container'>
        <div className='popup-content'>
          {/* 关闭按钮 */}
          <div className='popup-close' onClick={onClose}>
            <CloseOutlined />
          </div>

          {/* 标题 */}
          <div className='popup-header'>
            <h2 className='popup-title'>{title}</h2>
          </div>

          {/* 内容区域 */}
          <div className='popup-body'>{children}</div>

          {/* 提示信息 */}
          {tips && (
            <div className='popup-tips'>
              <div className='tips-content'>{tips}</div>
            </div>
          )}

          {/* 底部按钮区域 */}
          {footer && showButton && <div className='popup-footer'>{footer}</div>}
        </div>
      </div>
    </>
  );
};

export default BasePopup;
